<template>
    <div class="container p-21 px-4">
        <div class="pagination-container d-flex flex-column1 flex-sm-row align-items-center">
            <!-- <div class="d-flex flex-row align-items-center justify-content-center">
                <label class="text-nowrap">{{TR.rowPerPage}}</label>
                <select
                    class="form-select bg-transparent text-white border-secondary ms-2"
                    style="width: 100px;"
                    @change="changePageRowCount($event)"
                >
                    <template v-for="(pc, ind) in page_row_count" :key="ind">
                        <option :value="pc" :selected="pc==pageRowCount ? true : false">{{pc}}</option>
                    </template>
                </select>
            </div> -->
            <div
                class="d-none d-sm-flex ms-sm-auto1 me-sm-5 align-items-center justify-content-center"
            >
                <!-- <span class="text-secondary pe-4">|</span> -->
                <label class="text-nowrap">{{$filters.replace($filters.replace(TR.table_total_row, '{row_count}', row_count), '{pages_count}', pages_count)}}</label>
                <!-- <span class="text-secondary ps-4 me-sm-5">|</span> -->
            </div>
            <div
                class="d-flex flex-row align-items-center justify-content-center"
                v-if="pages_count > 5"
            >
                <label class="text-nowrap">{{TR.current_page}}</label>
                <input
                    id="toPage"
                    type="number"
                    min="1"
                    :max="pages_count"
                    class="form-control bg-transparent text-white border-secondary ms-2"
                    style="width: 80px;"
                    :value="currentPage"
                    @keyup="changePageOnEnter"
                />
                <button class="btn btn-primary me-sm-5" @click="changePage()">
                    <i class="fas fa-angle-right"></i>
                </button>
            </div>
            <div>
                <nav v-if="pages_count > 1">
                    <ul
                        class="pagination m-0 d-flex align-items-center justify-content-center"
                    >
                        <template v-if="pages_count>5">
                            <li class="page-item" :class="currentPage == 1 ? 'disabled' : ''">
                                <a class="page-link" @click="changePage(1)">
                                    <i class="fas fa-angle-double-left"></i>
                                </a>
                            </li>
                            <li class="page-item" :class="currentPage == 1 ? 'disabled' : ''">
                                <a class="page-link" @click="changePage(start == 0 ? 1 : start)">
                                    <i class="fas fa-angle-left"></i>
                                </a>
                            </li>
                        </template>
                        <li
                            class="page-item"
                            :class="currentPage == pg ? 'active' : ''"
                            v-for="(pg, index) in pages"
                            :key="index"
                        >
                            <a class="page-link" @click="changePage(pg)">{{pg}}</a>
                        </li>
                        <template v-if="pages_count>5">
                            <li
                                class="page-item"
                                :class="currentPage >= pages_count ? 'disabled' : ''"
                            >
                                <a class="page-link" @click="changePage( end < pages_count ? (end+1) : end )">
                                    <i class="fas fa-angle-right"></i>
                                </a>
                            </li>
                            <li
                                class="page-item"
                                :class="currentPage >= pages_count ? 'disabled' : ''"
                            >
                                <a class="page-link" @click="changePage(pages_count)">
                                    <i class="fas fa-angle-double-right"></i>
                                </a>
                            </li>
                        </template>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
    import { onMounted, ref, watchEffect } from "vue";
    import { useStore } from "@/system_modules/store";

    export default {
        name: 'PaginationC',
        props: ['pages_count', 'row_count', 'current_page', 'perpage'],
        emits: ['navigate'],
        setup(props, {emit}) {
            const store = useStore();

            const TR = ref({});
            const currentPage = ref(1);
            const pages = ref([]);
            const pageRowCount = ref(6);

            const page_row_count = [1, 2, 4, 6, 12, 24, 48];
            const start = ref(0);
            const end = ref(0);

            const navigate = (page, rows) => {
                createPageRange(page);
                emit('navigate', page, rows);
            };

            const changePageOnEnter = (e) => {
                if (e.which == 13) {
                    changePage();
                }
            };

            const changePage = (page) => {
                let cp;
                if (page === undefined)
                    cp = parseInt(document.getElementById("toPage").value);
                else cp = page;

                navigate(cp, pageRowCount.value);
            };

            const changePageRowCount = (event) => {
                let sel_row_count = parseInt(event.target.value);
                pageRowCount.value = sel_row_count;
                navigate(1, sel_row_count);
            };

            const createPageRange = (cp) => {
                let page_count = props.pages_count;
                let pagesl = [];

                if (page_count > 5) {
                    start.value = parseInt(Math.floor(Math.abs(cp - 1) / 5)) * 5;
                    end.value = start.value + 5;
                    if (end.value > page_count) end.value = page_count;
                } else {
                    start.value = 0;
                    end.value = page_count;
                }
                for (var i = start.value + 1; i <= end.value; i++) {
                    pagesl.push(i);
                }
                pages.value = pagesl;
            };

            watchEffect(() => {
                TR.value = store.getTranslation();
                currentPage.value = props.current_page;
                createPageRange(currentPage.value);
            });

            onMounted(() => {
                currentPage.value = parseInt(
                    props.current_page
                );
                pageRowCount.value = parseInt(
                    props.perpage
                );
                createPageRange(currentPage.value);
            });

            return {
                TR,
                changePage,
                changePageOnEnter,
                pages,
                currentPage,
                changePageRowCount,
                pageRowCount,
                page_row_count,
                start,
                end
            };
        },
    };
</script>

<style lang="scss"  scoped>
:root{
    --bs-pagination-padding-y: 0.275rem;
}
.pagination-container{
    height: 60px;
}
.page-item.active .page-link {
    // background: #0d6efd99;
    background: var(--background-pagination-gradient);
    color: #ffffff;
}
.page-link {
    color: #000000;
    background-color: #ffffff40;
    border: 0;
    cursor: pointer;
    // padding: 7px 15px;
}
.page-item.disabled .page-link {
    background-color: #00000050;
}
</style>